/**
 * @generated SignedSource<<c6119ee86422e02bc7430f19815461ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnlikeEpisodeInput = {
  episodeId: string;
  topicSlug: string;
};
export type DashboardHomeUnlikeMutation$variables = {
  input: UnlikeEpisodeInput;
};
export type DashboardHomeUnlikeMutation$data = {
  readonly unlikeEpisode: {
    readonly episode: {
      readonly id: string;
      readonly isLikedByViewer: boolean | null | undefined;
      readonly likeCount: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type DashboardHomeUnlikeMutation = {
  response: DashboardHomeUnlikeMutation$data;
  variables: DashboardHomeUnlikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnlikeEpisodePayload",
    "kind": "LinkedField",
    "name": "unlikeEpisode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Episode",
        "kind": "LinkedField",
        "name": "episode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLikedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likeCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardHomeUnlikeMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardHomeUnlikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a193d5d50c814b54fe548f23a02f2150",
    "id": null,
    "metadata": {},
    "name": "DashboardHomeUnlikeMutation",
    "operationKind": "mutation",
    "text": "mutation DashboardHomeUnlikeMutation(\n  $input: UnlikeEpisodeInput!\n) {\n  unlikeEpisode(input: $input) {\n    episode {\n      id\n      isLikedByViewer\n      likeCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e40c188a9c181f7284a947e6abff5dac";

export default node;
